import { Button, Tooltip } from '@profgeosoft-ui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ComparisonSidebar } from 'src/features/comparison-sidebar/comparison-sidebar';
import { ExportModal } from 'src/features/export-file';
import { ExportStore } from 'src/features/export-file/export-store';
import { PlanVersionSidebar } from 'src/features/plan-version-sidebar';
import CompareIcon from 'src/shared/assets/icons/compare-arrows.svg';
import { useModal } from 'src/shared/hooks/use-modal';
import { GOPLAN_DRILLING_CARPET_COMPARE_MODE } from 'src/store/roles-store/roles';
import { useStore } from 'src/store/use-store';

import { ExportButton } from '../../../../../features/export-file/export-button';

import styles from './compare-and-import-export.module.scss';
import { CompareButton } from './compare-button/compare-button';
import { UploadButton } from './upload-button';

export const CompareAndImportExport = observer(function CompareAndImportExport() {
  const { comparison, planVersion, editing, exportService, planVersionsService, notifications, rolesStore } =
    useStore();
  const { t } = useTranslation('drillingCarpet');
  const location = useLocation();
  const {
    isOpen: isPlanVersionSidebarOpen,
    openModal: openPlanVersionSidebar,
    closeModal: closePlanVersionSidebar,
  } = useModal();

  const isInPadPreparation = location.pathname.includes('wellPadPreparation');

  const [exportStore] = useState(() => new ExportStore(exportService, planVersionsService, notifications, rolesStore));

  useEffect(() => {
    exportStore.init();
  }, [exportStore]);

  return (
    <>
      <div className={styles.wrapper}>
        {comparison.isComparing && (
          <p className={clsx(styles.comparingText, comparison.isComparing && styles.hidden)}>
            {t('Compare.comparison')}
          </p>
        )}

        {!isInPadPreparation && (
          <CompareButton
            currentPlan={comparison.isComparing ? comparison.firstTargetPlan : planVersion.version || null}
            placeholder={t('Compare.chooseTarget')}
            handleOpenSidebar={comparison.isComparing ? comparison.openSidebar : openPlanVersionSidebar}
            isDisabled={editing.isEditing}
          />
        )}

        {comparison.isComparing && <p className={styles.comparingText}>{t('Compare.with')}</p>}
        {comparison.isComparing && (
          <CompareButton
            currentPlan={comparison.secondTargetPlan}
            placeholder={t('Compare.chooseDraft')}
            handleOpenSidebar={comparison.openSidebar}
          />
        )}

        <div className={styles.iconsWrapper}>
          {rolesStore.hasAccess([GOPLAN_DRILLING_CARPET_COMPARE_MODE]) && (
            <Tooltip title={t('common:compare')}>
              <Button
                variant="flat"
                onClick={comparison.openSidebar}
                icon={<CompareIcon className={styles.icon} />}
                disabled={comparison.isComparing || editing.isEditing}
                className={styles.iconButton}
              />
            </Tooltip>
          )}

          <ExportButton exportStore={exportStore} />
          <UploadButton />
        </div>
      </div>

      <PlanVersionSidebar isOpen={isPlanVersionSidebarOpen} onClose={closePlanVersionSidebar} />
      <ComparisonSidebar />
      <ExportModal exportStore={exportStore} />
    </>
  );
});
